'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserCommissionScheduleBand } from '../../Entities/User/UserCommissionScheduleBand';
import { UserCommissionScheduleBandCollection } from '../../Collections/User/UserCommissionScheduleBandCollection';

export class UserCommissionScheduleBandRepository extends CoreRepository {
  public createUserCommissionScheduleBand(
    userId: number,
    commissionId: number,
    scheduleId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .createUserCommissionScheduleBand(userId, commissionId, scheduleId, payload)
      .then((response) => {
        const userCommission = new UserCommissionScheduleBand();
        userCommission.hydrate(response);

        return userCommission;
      });
  }

  public updateUserCommissionScheduleBand(
    userId: number,
    commissionId: number,
    scheduleId: number,
    bandId: number,
    payload: object = {}
  ) {
    return this.webAPI
      .updateUserCommissionScheduleBand(userId, commissionId, scheduleId, bandId, payload)
      .then((response) => {
        const userCommission = new UserCommissionScheduleBand();
        userCommission.hydrate(response);

        return userCommission;
      });
  }

  public getUserCommissionScheduleBands(
    userId: number,
    commissionId: number,
    scheduleId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI
      .getUserCommissionScheduleBands(userId, commissionId, scheduleId, options)
      .then((response) => {
        const collection = new UserCommissionScheduleBandCollection();

        response.data.forEach((collectionItemData) => {
          const collectionItem = new UserCommissionScheduleBand();
          collectionItem.hydrate(collectionItemData);

          collection.addItem(collectionItem);
        });

        collection.setOffset(response.offset);
        collection.setLimit(response.limit);
        collection.setTotal(response.total);

        return collection;
      });
  }

  public removeUserCommissionScheduleBand(
    userId: number,
    commissionId: number,
    scheduleId: number,
    bandId: number
  ) {
    return this.webAPI
      .removeUserCommissionScheduleBand(userId, commissionId, scheduleId, bandId)
      .then((response) => {
        return response;
      });
  }

  public removeUserCommissionScheduleBands(
    userId: number,
    commissionId: number,
    scheduleId: number
  ) {
    return this.webAPI
      .removeUserCommissionScheduleBands(userId, commissionId, scheduleId)
      .then((response) => {
        return response;
      });
  }
}
